import { Settings } from 'lucide-react';
import { memo } from 'react';

import { useDialog } from '@/app/providers/modal-provider/modal-provider.tsx';
import Button from '@/shared/ui/chat/ui/button';

import { AddIntegrationsModal } from './ui/add-integrations-modal';

export const AddIntegrations = memo(() => {
  const { openDialog } = useDialog();

  return (
    <Button
      className="!bg-transparent flex gap-1 text-sm"
      onClick={() => openDialog(() => <AddIntegrationsModal />)}
    >
      <Settings className="w-[20px]" />
      {/* <TypographyP className="!m-0">Интеграции</TypographyP> */}
    </Button>
  );
});
